export default function DetectOldBrowsers() {
    const ua = window.navigator.userAgent

    // Internet Explorer 10 and below
    const msie = ua.indexOf('MSIE ')
    if (msie > 0) {
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
    }

    // Internet Explorer 11
    const trident = ua.indexOf('Trident/')
    if (trident > 0) {
        const rv = ua.indexOf('rv:')
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
    }

    // Legacy Edge (EdgeHTML 12-18)
    const edge = ua.indexOf('Edge/')
    if (edge > 0) {
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
    }

    // Safari < 10 (Old WebKit)
    const isSafari = /^((?!chrome|android).)*safari/i.test(ua)
    const safariVersionMatch = ua.match(/Version\/(\d+)\./)
    if (isSafari && safariVersionMatch && parseInt(safariVersionMatch[1], 10) < 10) {
        return parseInt(safariVersionMatch[1], 10)
    }

    // Old Chrome (blocks versions older than 60)
    const chromeMatch = ua.match(/Chrome\/(\d+)\./)
    if (chromeMatch && parseInt(chromeMatch[1], 10) < 60) {
        return parseInt(chromeMatch[1], 10)
    }

    // Old Firefox (blocks versions older than 60)
    const firefoxMatch = ua.match(/Firefox\/(\d+)\./)
    if (firefoxMatch && parseInt(firefoxMatch[1], 10) < 60) {
        return parseInt(firefoxMatch[1], 10)
    }

    // If no outdated browser was detected, return false
    return false
}